import React from 'react';
import PropTypes from 'prop-types';
import { LABEL_SUFFIX } from 'utils/constants';
import { generateHTMLIdFromKeyPath } from 'utils/idUtils';

export default function RadioButton(props) {
  const {
    omitBorder = false,
    disabled = false,
    field,
    keyPath,
    label,
    onRadioButtonChange,
    radioGroupName,
    stacked = false,
    value = false,
  } = props;

  const inputId = generateHTMLIdFromKeyPath([...keyPath, field]);
  const labelId = inputId.concat(LABEL_SUFFIX);
  const fieldName = [...keyPath, ...radioGroupName.split(' ')].join('-');
  const disabledCursorStyles = disabled ? { cursor: 'not-allowed' } : {};
  const borderClasses = omitBorder ? '' : ' border border-secondary border-left-0';
  const layoutClasses = stacked ? ' mb-1' : ' form-check-inline py-1 px-3 m-0';
  return (
    <div
      className={`form-check${layoutClasses}${borderClasses}`}
      style={disabledCursorStyles}
    >
      <input
        style={disabledCursorStyles}
        aria-labelledby={labelId}
        className="form-check-input"
        checked={value}
        disabled={disabled}
        id={inputId}
        name={fieldName.toLowerCase()}
        type="radio"
        value={value}
        onChange={() => onRadioButtonChange(keyPath, field)}
      />
      <label
        id={labelId}
        className="form-check-label"
        htmlFor={inputId}
        style={disabledCursorStyles}
      >{label}
      </label>
    </div>
  );
}

RadioButton.propTypes = {
  omitBorder: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.string.isRequired,
  keyPath: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
  onRadioButtonChange: PropTypes.func.isRequired,
  radioGroupName: PropTypes.string.isRequired,
  stacked: PropTypes.bool,
  value: PropTypes.bool,
};
